import styled from "styled-components";

export const ModalContent = styled.div`
  overflow: scroll;
  background-color: #fff;

  @media (min-width: 768px) {
    padding: 1rem 0;
  }
`;


export const Title = styled.div`
  font-size: 16px;
  color: #000FFF;
  cursor: pointer;

  @media (max-width: 768px){
    font-size: 15px;
  }
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 12px;
  font-weight: 300;
`;


export const DownloadIcon = styled.i`
  cursor: pointer;
  color: #487cf5;
  font-size: 25px;
`;

export const Divisor = styled.div`
  width: 1px;
  height: 51px;
  background-color: #707070;
  margin-left: 15px;
  margin-right: 15px;
  @media (max-width: 768px){
    visibility: hidden;
  }
`

export const Details = styled.div`
  padding: 0px 10px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #FFF;
  font-size: 12px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}

export const Left = styled.div`
  cursor: pointer;
  margin-left: 23px;
  display:flex;
  justify-content: space-between;
  align-items:center;
  flex-direction:row;

  @media (max-width: 770px) {
    width: 85%;
    justify-content: space-between;
  }
`

export const Right = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;
  flex-direction:row;

  @media(max-width: 770px) {
    flex-wrap: wrap;
    display: none;
    justify-content: space-between;
    width: 85%;
  }
`

export const DownloadButton = styled.div`
  margin-left: .5rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  @media(min-width: 770px) {
    margin-left: 10px;
  }
`;

export const BoxTitle = styled.div`
  display: flex;
  align-items: center;

  @media(max-width: 770px) {
    margin: 3rem 0 0 0;
  }

  @media(min-width: 770px) {
    width: 150px;
  }
`;

export const Dates = styled.div`
  display: flex;

  @media(max-width: 770px) {
    flex-direction: column;
  }
`;

export const TitleModal = styled.h4`
  font-size: 14px;
  color: #000FFF;
  display: flex;
  margin-left: 33px;
  margin-bottom: 0;

  @media(max-width: 770px) {
    margin-left: 23px;
  }

  div {
    font-weight: 550;
    border-right: 1px solid #000FFF;
    margin-right: .5rem;
    padding-right: .5rem;
  }
`;

export const DivisionTitleModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .5rem;

  img {
    margin-right: 23px;
    cursor: pointer;
  }
`;

export const DocumentContainer = styled.div`

  @media(max-width: 770px) and (max-height: 845px) {
    height: 39.3rem;
  }

  @media(max-width: 770px) and (max-height: 825px) {
    height: 38.7rem;
  }

  @media(max-width: 770px) and (max-height: 810px) {
    height: 37.7rem;
  }

  @media(max-width: 770px) and (max-height: 790px) {
    height: 36.4rem;
  }

  @media(max-width: 770px) and (max-height: 765px) {
    height: 34.8rem;
  }

  @media(max-width: 770px) and (max-height: 750px) {
    height: 33.6rem;
  }

  @media(max-width: 770px) and (max-height: 730px) {
    height: 32.5rem;
  }

  @media(max-width: 770px) and (max-height: 710px) {
    height: 31.5rem;
  }

  @media(max-width: 770px) and (max-height: 690px) {
    height: 30.5rem;
  }

  @media(max-width: 770px) and (max-height: 670px) {
    height: 29.4rem;
  }

  @media(max-width: 770px) and (max-height: 650px) {
    height: 28.4rem;
  }

  @media(max-width: 770px) and (max-height: 630px) {
    height: 27.4rem;
  }

  @media(max-width: 770px) and (max-height: 610px) {
    height: 26rem;
  }

  @media(max-width: 770px) and (max-height: 600px) {
    height: 25rem;
  }

  @media(max-width: 770px) and (max-height: 580px) {
    height: 24rem;
  }

  @media(max-width: 770px) and (max-height: 570px) {
    height: 23rem;
  }

  @media(max-width: 770px) and (max-height: 560px) {
    height: 22rem;
  }

  @media(max-width: 430px) {
    width: 22rem;
  }

  @media(max-width: 390px) {
    width: 20rem;
  }

  @media(max-width: 380px) {
    width: 19rem;
  }

  @media(max-width: 370px) {
    width: 18rem;
  }

  @media(max-width: 350px) {
    width: 17.8rem;
  }

  @media(max-width: 770px) {
    overflow: scroll;
    margin: 0% 0% 10% 0%;

    ::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3) !important;
      -webkit-border-radius: 10px !important;
      border-radius: 10px !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px !important;
      border-radius: 10px !important;
      background: #C1C1C1 !important;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5) !important;

    }
    ::-webkit-scrollbar-thumb:window-inactive {
      background: #C1C1C1 !important;
    }

    .text-center {
      transform: translate(50px, 50px) !important;
      overflow: scroll !important;
    }
  }
`;
